export default __webpack_public_path__ + "static/media/instagram.8dff4301.svg";